import {useAppSelector} from "@/store";
import {AdminState} from "@/store/slices/admin";

export const useAdminStore = (): AdminState => {
  return useAppSelector(state => state.admin)
}
